'use client';

import { useQuery } from '@tanstack/react-query';
import { audioStoryKeys } from '../queryKeys';
import { getAudioStory } from '../actions/getAudioStory';
import type { AudioStory } from '../types';

export function useAudioStory(audioStoryId: string | null | undefined) {
  return useQuery<AudioStory | null>({
    queryKey: audioStoryKeys.detail(audioStoryId ?? ''),
    queryFn: () => getAudioStory(audioStoryId!),
    enabled: !!audioStoryId,
  });
}
